import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Address } from './address';
export { Address };
import { addressSchema } from '@schemas/business-objects/address';
import { CandidateFormGroup } from './candidate-form-group';

export class AddressFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    legalAddress: SchemaFormControl;
    city: SchemaFormControl;
    country: SchemaFormControl;
    currentAddress: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<Address>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(addressSchema, Address, data, options);
  }

  get object(): Address {
    return new Address(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class AddressFormArray extends PersistedFormArray {
  readonly entityName = 'Address' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(addressSchema, Address, options);
  }

  protected override createItemGroup() {
    return new AddressFormGroup();
  }

  get array(): Address[] {
    return this.controls.map((group: AddressFormGroup) => group.object);
  }
}

export class AddressPersistedArray extends PersistedArray<Address> {
  readonly entityName = 'Address' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Address, options);
  }
}
